import { Loader2 } from "lucide-react";
import { useSacredPage } from "@/hooks/useSacredPage";
import { UniversalPageRenderer } from "./UniversalPageRenderer";
import { blockSections } from "@/lib/sacred-pages/cms-helpers";

const TAB_SLUGS = {
  archetypes: "archetypes",
  gates: "karmic-gates",
  adhikara: "adhikara-levels",
  pathways: "pathways",
};

/** Tab-specific CMS intro (block sections only) */
export function KnowledgeTabCms({ activeTab }) {
  const slug = TAB_SLUGS[activeTab];
  const { page, loading } = useSacredPage(slug);

  if (!slug) return null;
  if (loading) {
    return (
      <div className="flex justify-center py-6">
        <Loader2 className="w-6 h-6 animate-spin text-primary" />
      </div>
    );
  }

  const blocks = blockSections(page);
  if (!blocks.length) return null;

  return (
    <div className="mb-8">
      <UniversalPageRenderer page={page} className="max-w-4xl" />
    </div>
  );
}
